import { Injectable } from '@angular/core';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigViewModelService {

  private dataTransformConfigViewModel?: DataTransformConfigViewModel;
  private configViewModelSubject = new Subject<DataTransformConfigViewModel>();
  configViewModel$: Observable<DataTransformConfigViewModel>;

  constructor() {
    this.configViewModel$ = this.configViewModelSubject.asObservable();
  }

  setDataTransformConfigViewModel(vm: DataTransformConfigViewModel): void {
    this.configViewModelSubject.next(vm);
    this.dataTransformConfigViewModel = vm;

    //console.log('setting data transform config view model');
    //console.log(vm);
  }

  getDataTransformConfigViewModel(): DataTransformConfigViewModel {
    return this.dataTransformConfigViewModel;
  }
}
